import React from "react";
import { ShipmentProcessesProvider } from "../contexts/ShipmentProcessesContext";

const withShipmentProcesses = (WrappedComponent) => {
  return function WithShipmentProcesses(props) {
    return (
      <ShipmentProcessesProvider>
        <WrappedComponent {...props} />
      </ShipmentProcessesProvider>
    );
  };
};

export default withShipmentProcesses;
